import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-company-message',
    templateUrl: './company-message.component.html',
    styleUrls: ['./company-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyMessageComponent implements OnInit {
  @Input()
  author
  @Input()
  subject
  @Input()
  text
  @Output()
  close = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
